import Highway from '@dogstudio/highway/src/highway'
import '../scss/_404.scss'

export default class Page404 extends Highway.Renderer {}
